import React from "react";
import SeoForm from "./components/SeoForm";

function AddCategorySeo() {
  return <SeoForm entityType="category" />;
}

export default AddCategorySeo;
